import axios from 'axios';
import axiosInstance from '../../_utils/axiosConfig';

let Inscription : any = {};
Inscription.submitForm = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/register`, data)
}

export default Inscription;